export default "__VITE_ASSET__CMsD0uuB__"